var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDate, IsEnum, IsInt, IsISO8601, IsNumber, IsOptional, IsString, IsUUID, Min, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { AppointmentSeriesStatus } from '../../appointments/enums/appointment-series-status.enum.js';
export class AppointmentSeriesParticipantResponseDto {
    id;
    patientId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesParticipantResponseDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesParticipantResponseDto.prototype, "patientId", void 0);
export class AppointmentSeriesResponseDto {
    id;
    createdAt;
    updatedAt;
    rrule;
    dtstartLocal;
    tzid;
    exdates;
    ruleVersion;
    status;
    expectedOccurrenceCount;
    treatmentPlanId;
    defaultTherapistId;
    defaultRoomId;
    defaultOfficeLocationId;
    defaultOfficeProductAssignmentId;
    defaultTreatmentLocation;
    defaultPlannedDuration;
    defaultService;
    defaultDescription;
    defaultBillableServiceItemIds;
    defaultDeviceIds;
    defaultParticipants;
    icsUid;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "id", void 0);
__decorate([
    IsDate(),
    Exclude(),
    __metadata("design:type", Date)
], AppointmentSeriesResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDate(),
    Exclude(),
    __metadata("design:type", Date)
], AppointmentSeriesResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "rrule", void 0);
__decorate([
    IsISO8601(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "dtstartLocal", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "tzid", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], AppointmentSeriesResponseDto.prototype, "exdates", void 0);
__decorate([
    IsInt(),
    Expose(),
    __metadata("design:type", Number)
], AppointmentSeriesResponseDto.prototype, "ruleVersion", void 0);
__decorate([
    IsEnum(AppointmentSeriesStatus),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "status", void 0);
__decorate([
    IsInt(),
    Min(1),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "expectedOccurrenceCount", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultTherapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultRoomId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultOfficeLocationId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultOfficeProductAssignmentId", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    Expose(),
    __metadata("design:type", String)
], AppointmentSeriesResponseDto.prototype, "defaultTreatmentLocation", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], AppointmentSeriesResponseDto.prototype, "defaultPlannedDuration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultService", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "defaultDescription", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    Expose(),
    __metadata("design:type", Array)
], AppointmentSeriesResponseDto.prototype, "defaultBillableServiceItemIds", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    Expose(),
    __metadata("design:type", Array)
], AppointmentSeriesResponseDto.prototype, "defaultDeviceIds", void 0);
__decorate([
    ValidateNested({ each: true }),
    Type(() => AppointmentSeriesParticipantResponseDto),
    Expose(),
    __metadata("design:type", Array)
], AppointmentSeriesResponseDto.prototype, "defaultParticipants", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], AppointmentSeriesResponseDto.prototype, "icsUid", void 0);
//# sourceMappingURL=appointment-series-response.dto.js.map